import {AxiosResponse} from "axios"
import {IStandardResponse} from "../types";
import {IBuildInfo} from "../utils/buildInfo";
import {apiClient} from "./apiClient"

export const loadServerBuildInfo = async (): Promise<IBuildInfo> => {
    const res: AxiosResponse<IStandardResponse<IBuildInfo>> = await apiClient.get("/version")
    return res.data.data
}
